import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ size = "md", text = "Loading...", variant = "primary" }) => {
    const sizeMap = {
        sm: { width: '1rem', height: '1rem' },
        md: { width: '2rem', height: '2rem' },
        lg: { width: '3rem', height: '3rem' }
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center p-4">
            <Spinner 
                animation="border" 
                variant={variant}
                style={sizeMap[size]}
                aria-label={text}
            />
            <span className="mt-2 text-muted">{text}</span>
        </div>
    );
};

LoadingSpinner.propTypes = {
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    text: PropTypes.string,
    variant: PropTypes.string
};

export default LoadingSpinner;
